import Select from '../components/Select';

export default class StaticBlog {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.initializedClass = 'blog-initialized';
    this._validate();
  }

  onSectionLoad() {
    this._validate();
  }

  onSectionUnload() {
    $(window).off('resize.blog-view');
  }

  _validate() {
    if (window.innerWidth <= 1080) {
      this.positionSidebar('below');
    } else {
      this.positionSidebar();
    }

    this.setupFeaturedImage();
    this.setupFullWidthImages();

    $(window).on('resize.blog-view', () => {
      this.setupFullWidthImages();
      if (window.innerWidth <= 1080) {
        this.positionSidebar('below');
      } else {
        this.positionSidebar();
        this.setupFeaturedImage();
      }
    });

    if ($('.blog-tag-filter select', this.$el).length) {
      new Select({
        el: $('.blog-tag-filter select', this.$el),
      });
      $('.blog-tag-filter select').on('change', event => this.filterBlog(event));
    }
  }

  filterBlog(e) {
    if (!this.$el.find('[data-tag-filter]').length) {
      return;
    }

    const tag = $(e.target).val();
    const url = $(e.target).data('url');

    window.location.href = tag === 'all'
      ? `/blogs/${url}`
      : `/blogs/${url}/tagged/${tag}`;
  }

  setupFeaturedImage(setup) {
    const result = [];
    $('.blog-post', this.$el).each((index, post) => {
      post = $(post);

      const image = post.find('img.highlight').first();
      if (image.length) {
        image.on('rimg:load', () => {
          post
            .find('.blog-post-inner')
            .css({ paddingTop: image.height() - 60 });
        });
      }
    });
  }

  setupFullWidthImages() {
    const postContent = $('.post-content', this.$el);
    const postContentWidth = postContent.outerWidth(true);
    const postContentMargin = postContent.css('marginLeft');
    const result = [];

    $('img.full-width').each((index, image) => {
      image = $(image);

      image.css({
        width: postContentWidth,
        left: `-${postContentMargin}`,
      });
    });
  }

  positionSidebar(position) {
    const sidebar = $('.blog-sidebar', this.$el);

    if (position === 'below') {
      sidebar.insertAfter('.blog-posts');
    } else {
      sidebar.insertBefore('.blog-posts');
    }
  }
}
